// ** React Imports
import { useContext } from "react";

// ** Redux
import { useSelector } from "react-redux";

// ** Custom Components
import Block from "components/layout/Block";

// ** Utils & Helpers
import cdnPrefixer from "helpers/cdnPrefixer";
import hasDefaultAvatarFunc from "helpers/hasDefaultAvatar";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Third Party Components
import styled from "styled-components";

// ** Styles
import { StyledBluredAvatarContainer, StyledBluredAvatar } from "./styles";

const StyledWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	position: relative;
	padding: 1rem;
	height: ${({ $isDesktop }) => ($isDesktop ? "260px" : "240px")};
`;

// #####################################################

const HeroSectionDesktopNew = ({ avatarSrc, children }) => {
	const { isDesktop } = useContext(deviceTypeContext);

	const hasDefaultAvatar = hasDefaultAvatarFunc(avatarSrc);

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	// #####################################################

	return (
		<StyledWrapper $isDesktop={isDesktop}>
			<StyledBluredAvatarContainer hasDefaultAvatar={hasDefaultAvatar}>
				{!hasDefaultAvatar && (
					<StyledBluredAvatar
						src={cdnPrefixer(avatarSrc)}
						alt="Background"
					/>
				)}
			</StyledBluredAvatarContainer>
			<Block
				absolute
				zIndex={2}
				style={{
					backgroundColor: "rgba(0, 0, 0, 0.5)",
					borderTopLeftRadius: "var(--dz-sys-card-border-radius)",
					borderTopRightRadius: "var(--dz-sys-card-border-radius)",
					overflow: "hidden",
				}}
			></Block>
			<Block
				relative
				zIndex={3}
				onClick={() => !isAuth && window.scrollTo(0, 0)}
			>
				{children}
			</Block>
		</StyledWrapper>
	);
};

// #####################################################

export default HeroSectionDesktopNew;

// #####################################################
